// LoginLabel.jsx

import React from 'react';

// CSS
import './LoginLabel.css';

/**
 * LoginLabel Component
 * 
 * This component renders a label for login form fields.
 * 
 * @param {string} text - The text of the label.
 * 
 * @returns {ReactNode} The rendered component.
 */
const LoginLabel = ({ text, align = "left" }) => {

  // ----- RENDER ----- //

  return (

    <div
      className="login-label-container"
      style={{
        marginLeft: align === "left" ? "6px" : "0px",
        textAlign: align || "left",
      }}
    >
      {text}
    </div>

  );
};

// Dev Tools
LoginLabel.displayName = 'LoginLabel';

export default LoginLabel;
